import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subscription, catchError, finalize, throwError } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { UtilService } from 'src/app/services/util.service';
import {Location} from "@angular/common";
import {SecurityQuestionComponent} from "../security-questions/security-questions.component";

export interface DialogData {
  email: string;
}

@Component({
    selector: 'app-change-password',
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
    standalone: false
})
export class ForgotPasswordComponent {

  isLoading = false;
  constructor(public dialogRef: MatDialogRef<ForgotPasswordComponent>, private location: Location,
              @Inject(MAT_DIALOG_DATA) public data: DialogData, private httpService: HttpService, private util: UtilService, private dialog: MatDialog) { }

  onOk() {
    this.isLoading = true;
    const formData = { email: window.btoa(this.data.email) };
    const httpParams = this.httpService.createHttpParams(formData);

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    this.httpService.Post<any>('/user/forgot-password/submit-email', httpParams, options).pipe(
      finalize(() => { this.isLoading = false }),
      catchError(err => {
        return throwError(err);
      })
    ).subscribe(response => {
      if (response) {
        this.dialog.closeAll();
        if (response.message === "Email doesn't exist") {
          this.util.displayDialogMessage("Error",
            "A user account for the provided email does not exist. Please check if the email is correct.");
        } else if (response.message === "ROLE: VENDOR") {
          this.util.displayDialogMessage("Success",
            "A temporary password has been sent to your provided email address. Please use this temporary password to log into the system and create a new password. If you have not received your temporary password, please check your spam folder.");
        } else if (response.message === "ROLE: NON-VENDOR") {
          let data = response.data;
          if (data && data.account_status_id !== 4) {
            const dialogRef: MatDialogRef<SecurityQuestionComponent> = this.dialog.open(SecurityQuestionComponent, {
              data: data,
              width: '580px'
            });
          } else if (response.isNonVendorNewAcct) {
            this.util.displayDialogMessage("Error",
              "A user account for the provided email does not exist. Please check if the email is correct.");

          } else {
            this.util.displayDialogMessage("Account Locked",
              "Your account has been locked. Instructions on how to reset your account have been sent to your provided email address.");
          }
        } else {
          this.util.displayDialogMessage("Server Error",
            "A user account for the provided email does not exist. Please check if the email is correct.");
        }

      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
